import { render, staticRenderFns } from "./FormRegistration.vue?vue&type=template&id=2a6173f6&scoped=true&"
import script from "./FormRegistration.vue?vue&type=script&lang=js&"
export * from "./FormRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistration.vue?vue&type=style&index=0&id=2a6173f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6173f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VFooter,VRow,VSheet})
